export default function MapLoader () {
  return new Promise((resolve, reject) => {
    if (window.AMap) {
      resolve(window.AMap)
    } else {
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.src = 'https://webapi.amap.com/maps?v=1.4.15&callback=onAMapLoaded&key=3fb41b447a72c815a54d49d1a946169a'
      script.onerror = reject
      document.head.appendChild(script)
    }
    window.onAMapLoaded = () => {
      resolve(window.AMap)
    }
  })
}



// WEBPACK FOOTER //
// ./src/javascript/GdMap/Controller.js